var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ma-0 pa-0" },
    [
      _vm.isLoading
        ? _c(
            "v-layout",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                "z-index": "1000",
                background: "rgba(255, 255, 255, .95)"
              },
              attrs: { "align-center": "", "justify-center": "" }
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _c("div", { staticClass: "lds-roller" }, [
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Patientez SVP ...")])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            row: "",
            wrap: "",
            "mx-4": "",
            "pl-0": "",
            "mt-0": "",
            "mb-3": ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", "mt-2": "" } },
            [
              _c("h1", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.blockOverallInformations)))
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs2: "" } },
                [
                  _c("v-card", {
                    attrs: {
                      flat: "",
                      color: "secondary",
                      height: "1px",
                      width: "100%"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.currentEquipment
                ? _c(
                    "v-card",
                    {
                      staticClass: "py-3 pr-1 pl-4 mt-2",
                      class: { "grey--text": _vm.currentEquipment.disable }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c("v-flex", { attrs: { xs4: "" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "equipment--picture",
                                style: _vm.equipmentBgContainerStyle,
                                attrs: { size: "95%", color: "grey lighten-4" },
                                on: {
                                  mouseover: _vm.handleImageMouseOver,
                                  mouseleave: _vm.handleImageMouseLeave
                                }
                              },
                              [
                                _vm.currentEquipment.picture
                                  ? _c("img", {
                                      directives: [
                                        { name: "img", rawName: "v-img" }
                                      ],
                                      ref: "btn_zoom",
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        src: _vm.currentEquipment.picture
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hoverImg
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "equipment_picture_action"
                                      },
                                      [
                                        _vm.currentEquipment.picture
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  large: "",
                                                  color: "grey lighten-4",
                                                  icon: ""
                                                },
                                                on: {
                                                  click: _vm.handleZoomPicture
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("zoom_out_map")
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.currentEquipment.picture &&
                                        _vm.$route.meta["manage_equipment"]
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  large: "",
                                                  color: "grey lighten-4",
                                                  icon: ""
                                                },
                                                on: {
                                                  click: _vm.handleClickPicture
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("edit")])],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.currentEquipment.picture &&
                                        _vm.$route.meta["manage_equipment"]
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  large: "",
                                                  alt: "Add picture",
                                                  color: "grey lighten-4",
                                                  icon: ""
                                                },
                                                on: {
                                                  click: _vm.handleClickPicture
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("add")])],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.loadUpdateImage
                                  ? _c("v-progress-circular", {
                                      staticClass: "equipment_picture_action",
                                      attrs: {
                                        indeterminate: "",
                                        color: "secondary"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("input", {
                              ref: "file",
                              staticStyle: { display: "none" },
                              attrs: {
                                type: "file",
                                id: "file",
                                accept: "image/png, image/jpeg"
                              },
                              on: {
                                change: function($event) {
                                  _vm.handleFileUpload($event.target)
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "" } },
                                    [
                                      _c(
                                        "h3",
                                        { staticClass: "primary--text mb-1" },
                                        [_vm._v("Descriptif du véhicule")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mb-3",
                                          attrs: { xs3: "" }
                                        },
                                        [
                                          _c("v-card", {
                                            attrs: {
                                              flat: "",
                                              color: "secondary",
                                              height: "1px",
                                              width: "20%"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.currentEquipment.disable
                                        ? _c(
                                            "strong",
                                            { staticClass: "black--text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.lblSetting
                                                      .equipmentDetail.disable
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _c("b", [_vm._v("Immatriculation: ")]),
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentEquipment.reference ||
                                              "-"
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _c("b", [_vm._v("Marque: ")]),
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentEquipment.brand || "-"
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _c("b", [_vm._v("Modèle: ")]),
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentEquipment.name || "-"
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _c("b", [
                                          _vm._v(
                                            "Date de mise en circulation : "
                                          )
                                        ]),
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCostDate(
                                              _vm.currentEquipment
                                                .circulation_date
                                            ) || "-"
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _c("b", [_vm._v("Puissance : ")]),
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentEquipment.horsepower ||
                                              "-"
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.currentEquipment
                                        .fk_character_problem_lvl2
                                        ? _c("span", [
                                            _c("b", [_vm._v("Genre  : ")]),
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentEquipment.subcategory
                                                  .name || "-"
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _c("b", [_vm._v("Status   : ")]),
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentEquipment
                                              .vehicule_state || "-"
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "" } },
                                    [
                                      _c(
                                        "h3",
                                        { staticClass: "primary--text mb-1" },
                                        [_vm._v("Coûts du véhicule")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mb-3",
                                          attrs: { xs3: "" }
                                        },
                                        [
                                          _c("v-card", {
                                            attrs: {
                                              flat: "",
                                              color: "secondary",
                                              height: "1px",
                                              width: "20%"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.currentEquipment.cost,
                                        function(item, index) {
                                          return _vm.dtCost.length
                                            ? _c(
                                                "v-flex",
                                                {
                                                  key: item.scat_id,
                                                  attrs: { xs12: "" }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "costLink",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.goToTab(index)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.scat_name
                                                          ) + " :"
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.total || "-"
                                                          ) +
                                                          " €"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        }
                                      ),
                                      _vm._v(" "),
                                      !_vm.dtCost.length
                                        ? _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("span", [
                                                _c("b", [
                                                  _vm._v(
                                                    "Aucun enregistrement trouvé"
                                                  )
                                                ])
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.meta["view_equipment_attribute"] &&
              _vm.currentEquipment
                ? _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c("h1", { staticClass: "primary--text mt-2" }, [
                        _vm._v("Autres informations")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs1: "" } },
                        [
                          _c("v-card", {
                            attrs: {
                              flat: "",
                              color: "secondary",
                              height: "1px",
                              width: "100%"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "py-3 pr-1 pl-4 mt-2" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            _vm._l(_vm.currentEquipment.attributes, function(
                              item
                            ) {
                              return _c(
                                "v-flex",
                                {
                                  key: item.id,
                                  attrs: { xs12: "", md6: "", lg4: "" }
                                },
                                [
                                  _c("v-hover", {
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var hover = ref.hover
                                          return _c(
                                            "div",
                                            { staticStyle: { height: "30px" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "text-none text-xs-left",
                                                  attrs: {
                                                    disabled: !_vm.$route.meta[
                                                      "manage_equipment_attribute"
                                                    ],
                                                    flat: "",
                                                    color: "black"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.handleEditAttribute(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold pr-1"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.name) + ":"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  item.attribute_value
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              item
                                                                .attribute_type
                                                                .type === "date"
                                                                ? _vm.formatCostDate(
                                                                    item
                                                                      .attribute_value
                                                                      .value
                                                                  )
                                                                : item
                                                                    .attribute_value
                                                                    .value +
                                                                    " " +
                                                                    item.unit
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  hover
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            right: "",
                                                            color: "primary"
                                                          }
                                                        },
                                                        [_vm._v("edit")]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dtCost.length
                ? _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "h1",
                        {
                          staticClass: "primary--text mt-2",
                          attrs: { id: "cost-details" }
                        },
                        [_vm._v("Détail des coûts du véhicule")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs1: "" } },
                        [
                          _c("v-card", {
                            attrs: {
                              flat: "",
                              color: "secondary",
                              height: "1px",
                              width: "100%"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "py-3 pr-1 pl-4 mt-2" },
                        [
                          _c(
                            "v-tabs",
                            {
                              attrs: { "slider-color": "primary" },
                              model: {
                                value: _vm.CostTab,
                                callback: function($$v) {
                                  _vm.CostTab = $$v
                                },
                                expression: "CostTab"
                              }
                            },
                            [
                              _vm._l(_vm.dtCost, function(cost, index) {
                                return _c(
                                  "v-tab",
                                  { key: index, attrs: { ripple: "" } },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(cost.name) +
                                        "\n            "
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.dtCost, function(cost, index) {
                                return _c(
                                  "v-tab-item",
                                  { key: index, attrs: { ripple: "" } },
                                  [
                                    _c("v-data-table", {
                                      staticClass: "elevation-0",
                                      attrs: {
                                        headers: _vm.Costheaders,
                                        items: cost.costs,
                                        pagination: cost.pagination,
                                        "total-items": cost.total,
                                        loading: cost.loading,
                                        "rows-per-page-items": [10, 25, 50],
                                        "rows-per-page-text": "Lignes par page",
                                        "no-data-text":
                                          "Pas de données disponibles"
                                      },
                                      on: {
                                        "update:pagination": [
                                          function($event) {
                                            _vm.$set(cost, "pagination", $event)
                                          },
                                          function(pagination) {
                                            return _vm.updatePagination(
                                              pagination,
                                              cost.fk_category,
                                              cost.fk_subcategory
                                            )
                                          }
                                        ]
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "greyDark--text"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatCostDate(
                                                        props.item.billing_date
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "greyDark--text"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.provider)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "greyDark--text"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.quantity)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "greyDark--text"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.amount) +
                                                      "€"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "greyDark--text"
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        flat: "",
                                                        icon: "",
                                                        color: "primary",
                                                        href:
                                                          props.item
                                                            .invoice_link,
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        { attrs: { dark: "" } },
                                                        [_vm._v("receipt")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ])
                                    })
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("last-documents", {
                key: _vm.lastDocsKey,
                attrs: {
                  equipmentId: _vm.$route.params.cid,
                  equipmentName: _vm.getEquipmentName()
                },
                on: { "update-doc-by-id": _vm.updateDocById }
              }),
              _vm._v(" "),
              _vm.maintenances.length
                ? _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c("h1", { staticClass: "primary--text mt-2" }, [
                        _vm._v("Maintenances")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "mb-4", attrs: { xs1: "" } },
                        [
                          _c("v-card", {
                            attrs: {
                              flat: "",
                              color: "secondary",
                              height: "1px",
                              width: "100%"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            { staticStyle: { padding: "30px 90px 30px 90px" } },
                            _vm._l(_vm.maintenances, function(item) {
                              return _c(
                                "div",
                                { key: item.id },
                                [
                                  _c("maintenance-item", {
                                    attrs: { maintenance: item }
                                  })
                                ],
                                1
                              )
                            })
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtModalAttribute
        ? _c(
            "base-modal-duplicate",
            {
              attrs: {
                "show-create-another": false,
                loading: _vm.dtIsRecording,
                icon: "handyman",
                "icon-type": "icon",
                "submit-btn-title": _vm.$t(this.lblSetting.blockSave),
                "hide-default-action": true,
                title:
                  _vm.$t(this.lblSetting.blockEquipment.updateAttribute) +
                  _vm.currentAttribute.name,
                "is-dark-title": "",
                "max-width": "50vw",
                "before-close": _vm.handleBeforeModalClose
              },
              on: {
                onRecord: _vm.handleSaveAttribute,
                onClose: _vm.handleClose
              },
              model: {
                value: _vm.dtModalAttribute,
                callback: function($$v) {
                  _vm.dtModalAttribute = $$v
                },
                expression: "dtModalAttribute"
              }
            },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "", "px-0": "" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "form-section",
                      attrs: { "pl-4": "", xs12: "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { "pl-0": "", "pr-4": "", xs12: "" } },
                            [
                              _c("base-attribute-manager", {
                                attrs: { attribute: _vm.currentAttribute },
                                model: {
                                  value: _vm.attributeToEdit,
                                  callback: function($$v) {
                                    _vm.attributeToEdit = $$v
                                  },
                                  expression: "attributeToEdit"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          ref: "base-modal",
          attrs: {
            loading: _vm.dtIsRecording,
            "action-position": "center",
            icon: "document_bleu",
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.$t(_vm.lblSetting.documentSave),
            "hide-default-action": true,
            title: _vm.modalTitle,
            "max-width": "90%",
            "is-yellow-title": ""
          },
          on: { onRecord: _vm.handleSaveDoc, onClose: _vm.handleClose },
          model: {
            value: _vm.dtModalAddDoc,
            callback: function($$v) {
              _vm.dtModalAddDoc = $$v
            },
            expression: "dtModalAddDoc"
          }
        },
        [
          _c("document-modal-vertical", {
            attrs: { equipment: _vm.dtEquipment }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtMessageErrorModel
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleRemoveError }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b30fd6b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b30fd6b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-vehicle-detail/template.html
// module id = null
// module chunks = 